import React from "react";

import { DoctorAvatar, DoctorList } from "./style";

const DoctorDetails = ({ doctorList }) => {
  return (
    doctorList?.length > 0 && (
      <DoctorList>
        {doctorList?.map((doctor) => {
          return (
            <DoctorAvatar
              key={doctor.name}
              flexDirection="row"
              nameVariant="label2"
              layoutType={doctor.layout === "big"}
              {...doctor}
            />
          );
        })}
      </DoctorList>
    )
  );
};

export default DoctorDetails;
